import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BillingInvoiceComponent } from './billing-invoice/billing-invoice.component';
import { RentalInvoiceComponent } from './rental-invoice/rental-invoice.component';
import { Modules } from 'src/app/core/model/modules.enum';
import { Privileges } from 'src/app/core/model/privileges.enum';
import { ModuleGuard } from 'src/app/core/guard/module.guard';
import { MerchantBillingComponent } from './merchant-billing/merchant-billing.component';
import { MerchantBillingSettingsComponent } from './merchant-billing-components/merchant-billing-settings/merchant-billing-settings.component';
import { MerchantContractBillingComponent } from './merchant-contract-billing/merchant-contract-billing.component';
import { InvoiceDetailComponent } from './merchant-billing-components/invoice-detail/invoice-detail.component';

const routes: Routes = [
  {
    path: "TXN",
    component: BillingInvoiceComponent,
    canActivate: [ModuleGuard],
        data: { module: Modules.BILLING, privilege: Privileges.VIEW_INVOICE },
  },
  {
    path: "RENTAL",
    component: RentalInvoiceComponent,
    canActivate: [ModuleGuard],
        data: { module: Modules.RENTAL, privilege: Privileges.VIEW_RENTAL },
  },
  {
    path: 'm-b',
    component: MerchantBillingComponent,
     canActivate: [ModuleGuard],
        data: { module: Modules.MERCHANT_BILLING, privilege: Privileges.VIEW_BILLING },
  },
  {
    path: 'm-b-s',
    component: MerchantBillingSettingsComponent,
     canActivate: [ModuleGuard],
        data: { module: Modules.MERCHANT_BILLING, privilege: Privileges.VIEW_BILLING }
  },
  {
    path: 'merchant-contract',
    component: MerchantContractBillingComponent,
     canActivate: [ModuleGuard],
        data: { module: Modules.MERCHANT_BILLING, privilege: Privileges.VIEW_BILLING }
  },
  {
    path: 'invoice-details',
    component: InvoiceDetailComponent,
     canActivate: [ModuleGuard],
        data: { module: Modules.MERCHANT_BILLING, privilege: Privileges.VIEW_BILLING }
  }

]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BillingInvoiceRoutingModule { 
}
